import { useMemo } from 'react';

import { useFeatureGate } from '@trello/feature-gate-client';

const defaultGateValue = true;

/**
 * Custom hook to check if the feature gate `'gql_client_subscriptions'`
 * is on.
 * @returns true if the feature gate is enabled, false otherwise.
 */
export const useNativeBoardQuickloadAndSubscription = () => {
  const { value: subscriptionsGateEnabled } = useFeatureGate(
    'gql_client_subscriptions',
  );

  return useMemo(
    () => subscriptionsGateEnabled ?? defaultGateValue,
    [subscriptionsGateEnabled],
  );
};
